import { Search, X, CalendarRange } from "lucide-react";
import { cn } from "@/lib/utils";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Combobox } from "@/components/Combobox";
import { DatePicker } from "@/components/DatePicker";
import { MODES, PAY_OPTIONS } from "@/lib/pos";

const pad = (n) => String(n).padStart(2, "0");
const iso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
// Hızlı tarih aralıkları (yerel saat): Bugün · Dün · Bu Hafta (Pzt) · Bu Ay · Tümü
export const QUICK = [
  ["today", "Bugün"], ["yesterday", "Dün"], ["week", "Bu Hafta"], ["month", "Bu Ay"], ["all", "Tümü"], ["custom", "Tarih Aralığı"],
];
export const quickRange = (key) => {
  const now = new Date(); const t = iso(now);
  if (key === "today") return { start: t, end: t };
  if (key === "yesterday") { const d = new Date(now); d.setDate(d.getDate() - 1); const y = iso(d); return { start: y, end: y }; }
  if (key === "week") { const d = new Date(now); const dow = (d.getDay() + 6) % 7; d.setDate(d.getDate() - dow); return { start: iso(d), end: t }; }
  if (key === "month") return { start: `${t.slice(0, 7)}-01`, end: t };
  return { start: "", end: "" };
};
export const EMPTY_FILTER = { quick: "today", start: quickRange("today").start, end: quickRange("today").end, q: "", pay: "", mode: "", contact: "" };

export function HistoryFilters({ f, setF, contactOptions, count }) {
  const set = (patch) => setF((x) => ({ ...x, ...patch }));
  const pick = (k) => set(k === "custom" ? { quick: "custom" } : { quick: k, ...quickRange(k) });
  const active = f.q || f.pay || f.mode || f.contact || f.quick !== "today";
  return (
    <div className="space-y-2.5" data-testid="qs-history-filters">
      <div className="flex flex-wrap items-center gap-1.5">
        <div className="inline-flex items-center gap-0.5 rounded-xl bg-muted p-0.5" data-testid="qs-history-quick">
          {QUICK.map(([k, l]) => (
            <button key={k} type="button" onClick={() => pick(k)} data-testid={`sales-history-date-chip-${k}`}
              className={cn("rounded-[10px] px-3 h-8 text-xs font-bold transition-all whitespace-nowrap inline-flex items-center gap-1", f.quick === k ? "bg-card text-foreground shadow-sm ring-1 ring-border" : "text-muted-foreground hover:text-foreground")}>
              {k === "custom" && <CalendarRange className="h-3.5 w-3.5" />}{l}
            </button>
          ))}
        </div>
        {f.quick === "custom" && (
          <>
            <DatePicker value={f.start} onChange={(v) => set({ start: v })} placeholder="Başlangıç" className="h-8 w-36 rounded-lg text-xs" data-testid="qs-hist-start" />
            <DatePicker value={f.end} onChange={(v) => set({ end: v })} placeholder="Bitiş" className="h-8 w-36 rounded-lg text-xs" data-testid="qs-hist-end" />
          </>
        )}
        <span className="text-xs text-muted-foreground tnum ml-auto" data-testid="qs-history-filtered-count">{count} fiş</span>
      </div>
      <div className="flex flex-wrap items-center gap-1.5">
        <div className="relative flex-1 min-w-[220px]">
          <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input value={f.q} onChange={(e) => set({ q: e.target.value })} placeholder="Fiş no · ürün adı / kodu · müşteri ara…" className="h-9 pl-8 rounded-lg bg-card" data-testid="qs-hist-search" />
          {f.q && <button type="button" onClick={() => set({ q: "" })} className="absolute right-2 top-1/2 -translate-y-1/2 h-6 w-6 grid place-items-center rounded-md text-muted-foreground hover:bg-muted" data-testid="qs-hist-search-clear"><X className="h-3.5 w-3.5" /></button>}
        </div>
        <Select value={f.pay || "__all"} onValueChange={(v) => set({ pay: v === "__all" ? "" : v })}>
          <SelectTrigger className={cn("h-9 w-36 rounded-lg bg-card text-xs", f.pay && "border-primary/50 text-primary font-semibold")} data-testid="qs-hist-pay"><SelectValue placeholder="Ödeme" /></SelectTrigger>
          <SelectContent><SelectItem value="__all">Tüm Ödemeler</SelectItem>{PAY_OPTIONS.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}<SelectItem value="karma">Karma</SelectItem></SelectContent>
        </Select>
        <Select value={f.mode || "__all"} onValueChange={(v) => set({ mode: v === "__all" ? "" : v })}>
          <SelectTrigger className={cn("h-9 w-44 rounded-lg bg-card text-xs", f.mode && "border-primary/50 text-primary font-semibold")} data-testid="qs-hist-mode"><SelectValue placeholder="Satış Modu" /></SelectTrigger>
          <SelectContent><SelectItem value="__all">Tüm Modlar</SelectItem>{MODES.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}</SelectContent>
        </Select>
        <div className="w-56"><Combobox options={contactOptions} value={f.contact} onChange={(v) => set({ contact: v })} allowCustom placeholder="Cari filtrele" searchPlaceholder="Ünvan / VKN ara…" className="h-9 rounded-lg" data-testid="qs-hist-contact" /></div>
        {active && <button type="button" onClick={() => setF({ ...EMPTY_FILTER })} className="h-9 inline-flex items-center gap-1 rounded-lg px-2.5 text-xs font-semibold text-muted-foreground hover:text-foreground hover:bg-muted" data-testid="qs-hist-clear"><X className="h-3.5 w-3.5" />Temizle</button>}
      </div>
    </div>
  );
}
